import './Loading.css';

const Loading = () => {
    return (
      <span className='loading_gif'>
        <svg
          width="227px"
          height="227px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <circle cx="80" cy="50" r="5" fill="#1c4595">
            <animate
              attributeName="cx"
              values="80;65"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="cy"
              values="50;75.98076211353316"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="fill"
              values="#1c4595;#e76a24"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
          </circle>
          <circle cx="65" cy="75.98076211353316" r="5" fill="#e76a24">
            <animate
              attributeName="cx"
              values="65;35.00000000000001"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="cy"
              values="75.98076211353316;75.98076211353316"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="fill"
              values="#e76a24;#01080a"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
          </circle>
          <circle
            cx="35.00000000000001"
            cy="75.98076211353316"
            r="5"
            fill="#01080a"
          >
            <animate
              attributeName="cx"
              values="35.00000000000001;20"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="cy"
              values="75.98076211353316;50.00000000000001"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="fill"
              values="#01080a;#e7e5e8"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
          </circle>
          <circle cx="20" cy="50.00000000000001" r="5" fill="#e7e5e8">
            <animate
              attributeName="cx"
              values="20;34.999999999999986"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="cy"
              values="50.00000000000001;24.019237886466847"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="fill"
              values="#e7e5e8;#fbbc42"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
          </circle>
          <circle
            cx="34.999999999999986"
            cy="24.019237886466847"
            r="5"
            fill="#fbbc42"
          >
            <animate
              attributeName="cx"
              values="34.999999999999986;65"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="cy"
              values="24.019237886466847;24.019237886466843"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="fill"
              values="#fbbc42;#1c4595"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
          </circle>
          <circle cx="65" cy="24.019237886466843" r="5" fill="#1c4595">
            <animate
              attributeName="cx"
              values="65;80"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="cy"
              values="24.019237886466843;49.99999999999999"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
            <animate
              attributeName="fill"
              values="#1c4595;#1c4595"
              keyTimes="0;1"
              dur="0.31347962382445144s"
              repeatCount="indefinite"
            ></animate>
          </circle>
        </svg>
      </span>
    );
}

export default Loading;